// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import KeyValueDropDown from '../../shared/components/claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {buildNumber} from '../../../shared/services/build-number';

const ClaimsInProgressHeader = props =>
    <div className='claims-in-progress-header'>
        <h2>
            <FormattedMessage
                id='CLAIMS_IN_PROGRESS_WITH_COUNT'
                values={{
                    count: buildNumber(props.numberOfClaims)
                }}
            />
            <FavoriteIcon
                id='CLAIMS_IN_PROGRESS'
                route={props.pathName}
            />
        </h2>
        <div className='status-dropdown-export-button-group'>
            <KeyValueDropDown
                className='claim-statuses'
                list={props.allowedStatuses}
                onChange={props.onStatusChange}
                value={props.selectedStatus}
            />
        </div>
    </div>;

ClaimsInProgressHeader.displayName = 'ClaimsInProgressHeader';
ClaimsInProgressHeader.propTypes = {
    allowedStatuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    numberOfClaims: PropTypes.number.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    pathName: PropTypes.string.isRequired,
    selectedStatus: PropTypes.string.isRequired
};

export default ClaimsInProgressHeader;



// WEBPACK FOOTER //
// ./src/claim/claims-in-progress/components/claims-in-progress-header.js